module.exports = __webpack_public_path__ + "img/CUCS.df689dab.png";